<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.41291 3.08709C4.0468 2.72097 3.4532 2.72097 3.08709 3.08709C2.72097 3.4532 2.72097 4.0468 3.08709 4.41291L7.67423 9.00006L3.08709 13.5872C2.72097 13.9533 2.72097 14.5469 3.08709 14.913C3.4532 15.2791 4.0468 15.2791 4.41291 14.913L9.00006 10.3259L13.5871 14.9129C13.9532 15.279 14.5468 15.279 14.9129 14.9129C15.279 14.5468 15.279 13.9532 14.9129 13.5871L10.3259 9.00006L14.9129 4.41303C15.279 4.04691 15.279 3.45332 14.9129 3.0872C14.5468 2.72108 13.9532 2.72108 13.5871 3.0872L9.00006 7.67423L4.41291 3.08709Z"
      fill="#030134"
    />
  </svg>
</template>

<script>
export default {
  name: "IconClose"
};
</script>

<style></style>
